import { SUB_ROUTES } from "./TabMenu.constants";
import { PickActiveTabArgs, SubRoute } from "./TabMenu.decl";

export function pickActiveTab({
  pathname,
  tabs,
}: PickActiveTabArgs): SubRoute | undefined {
  if (SUB_ROUTES.every((route) => !pathname.includes(route))) {
    throw new Error("Invalid pathname");
  }

  const found = tabs.find((route) => pathname.includes(route));

  if (!found) {
    return;
  }

  return found;
}
